<template>
  <div>
    <div>
      <v-tabs
        v-model="tab"
        background-color="#efefef"
        grow
        color="grey"
        :slider-size="3"
      >
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab :key="'regular'"> บุคคลธรรมดา </v-tab>
        <v-tab :key="'juristic'"> นิติบุคคล</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="Kanit">
        <v-tab-item :key="'regular'">
          <v-container>
            <div class="mb-4 depahead">ลงทะเบียน</div>
            <div>
              <v-text-field
                label="ชื่อผู้ลงทะเบียน"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="นามสกุล"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="อีเมล"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="รหัสผ่าน"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="ยืนยันรหัสผ่าน"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div class="text-center">
              <v-btn
                @click="register"
                :loading="loading"
                depressed
                color="yellow"
                class="Kanit"
                >ลงทะเบียน</v-btn
              >
            </div>
          </v-container>
        </v-tab-item>
        <v-tab-item :key="'juristic'">
          <v-container>
            <div class="mb-4 registerhead">ลงทะเบียน</div>
            <div>
              <v-text-field
                label="ชื่อนิติบุคคล"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="ชื่อเจ้าของธุรกิจ"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="เบอร์โทรศัพท์ติดต่อ"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="อีเมล"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="รหัสผ่าน"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="ยืนยันรหัสผ่าน"
                outlined
                dense
                style="border-radius: 0"
              ></v-text-field>
            </div>
            <div class="text-center">
              <v-btn
                :loading="loading"
                @click="register"
                depressed
                color="yellow"
                class="Kanit"
                >ลงทะเบียน</v-btn
              >
            </div>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
      loading: false,
    };
  },
  methods: {
    async register() {
      this.loading = true;
      await this.$liff.sendMessages([
        {
          type: "text",
          text: "ลงทะเบียนสำเร็จ",
        },
      ]);
      await this.$liff.closeWindow();
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
</style>